import model from '@/router/base-info/car/category'
import ApiBase from '../api-base'
import { ACTIVE_BASE_REST } from '../constants'
export default class CmsComment extends ApiBase {
  constructor(store) {
    const path = ACTIVE_BASE_REST + '/blog/comment'
    super(store, path)
  }

  respond(id, model, showProgress) {
    return this._request({
      action: `${id}/respond`,
      method: 'PATCH',
      body: model,
      showProgress
    })
  }

  state(id, model, showProgress) {
    return this._request({
      action: `${id}/state`,
      method: 'PATCH',
      body: model,
      showProgress
    })
  }
}
